"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Vehicle_1 = require("../models/Vehicle");
var mockDriver_1 = __importDefault(require("./mockDriver"));
var mockVehicle = __assign(__assign({}, Vehicle_1.makeEmptyVehicle()), { brandId: '01', modelId: '02', modelYear: 2018, value: 50000, driver: mockDriver_1.default, luxuryTransportationService: false });
exports.default = mockVehicle;
//# sourceMappingURL=mockVehicle.js.map